import { useEffect } from "react";
import CatalogRequestForm from "@/components/CatalogRequestForm";

export default function CatalogRequestModal({ open, onClose }) {
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    if (open) {
      document.body.style.overflow = "hidden";
      window.addEventListener("keydown", onKey);
    }
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      data-testid="catalog-request-modal"
      className="fixed inset-0 z-[100] flex items-start sm:items-center justify-center p-0 sm:p-6 overflow-y-auto"
      style={{ background: "rgba(14,44,70,0.78)", backdropFilter: "blur(6px)" }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-2xl my-6 sm:my-0 border"
        style={{ background: "var(--surface)", borderColor: "var(--border-subtle)", boxShadow: "0 24px 60px rgba(14,44,70,0.35)" }}
      >
        <button
          onClick={onClose}
          data-testid="catalog-request-close"
          aria-label="Close"
          className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center text-2xl leading-none hover:text-[color:var(--brass)]"
          style={{ color: "var(--text-muted)" }}
        >
          ×
        </button>

        <div className="p-8 md:p-12">
          <div className="eyebrow mb-3">Catalog Request</div>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05] mb-3">
            Request a catalog.
          </h2>
          <p className="text-sm md:text-base mb-8" style={{ color: "var(--text-secondary)" }}>
            Drop your details — we&apos;ll mail the printed catalog and keep you in the loop on sale day updates.
          </p>
          <CatalogRequestForm />
        </div>
      </div>
    </div>
  );
}
